import React from "react";
import { useNavigate } from "react-router-dom";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

function EmptyState() {
  const navigate = useNavigate();

  return (
    <MDBox textAlign="center" mt={10}>
      <MDTypography variant="h4" fontWeight="bold" gutterBottom>
        No OAuth Request Found
      </MDTypography>

      <MDTypography variant="body1" mt={1} mb={3}>
        This page was opened without any active connection request.
      </MDTypography>

      <MDButton
        variant="contained"
        color="accent"
        onClick={() => navigate("/dashboard")}
      >
        Go to Dashboard
      </MDButton>
    </MDBox>
  );
}

export default EmptyState;
